import React from 'react';
import fullLogo from '../assets/littlelens-logo.svg';

interface LittleLensLogoProps {
  alt?: string;
  maxWidth?: number | string;
  maxHeight?: number | string;
  sx?: React.CSSProperties;
}

const LittleLensLogo: React.FC<LittleLensLogoProps> = ({
  alt = 'LittleLens',
  maxWidth = 110,
  maxHeight = 100,
  sx,
}) => (
  <img
    src={fullLogo}
    alt={alt}
    style={{
      display: 'block',
      width: '100%',
      height: 'auto',
      maxWidth,
      maxHeight,
      ...sx,
    }}
  />
);

export default LittleLensLogo;
